import React from 'react';
import Icon from '../../../components/AppIcon';

const ApprovalHeader = ({ orgName, orgLogo, ticketNumber, status }) => {
  const getStatusBadge = () => {
    switch (status) {
      case 'approved':
        return { label: 'Approved', bg: 'bg-emerald-100', text: 'text-emerald-700', icon: 'CheckCircle2' };
      case 'rejected':
        return { label: 'Rejected', bg: 'bg-red-100', text: 'text-red-700', icon: 'XCircle' };
      case 'expired':
        return { label: 'Expired', bg: 'bg-gray-100', text: 'text-gray-600', icon: 'Clock' };
      default:
        return { label: 'Awaiting Your Response', bg: 'bg-blue-100', text: 'text-blue-700', icon: 'Clock' };
    }
  };

  const badge = getStatusBadge();

  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-10 shadow-sm">
      <div className="max-w-3xl mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            {orgLogo ? (
              <img src={orgLogo} alt={`${orgName} logo`} className="h-9 w-auto object-contain" />
            ) : (
              <div className="w-9 h-9 bg-primary rounded-lg flex items-center justify-center">
                <Icon name="Wrench" size={18} color="white" />
              </div>
            )}
            <div>
              <p className="text-xs text-gray-500 font-medium uppercase tracking-wide">Service Approval</p>
              <p className="text-sm font-semibold text-gray-900">{orgName || 'FieldServicePro'}</p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            {ticketNumber && (
              <span className="hidden sm:block text-xs text-gray-500 font-mono bg-gray-100 px-2.5 py-1 rounded-md">
                #{ticketNumber}
              </span>
            )}
            <span className={`inline-flex items-center gap-1.5 text-xs font-semibold px-3 py-1.5 rounded-full ${badge?.bg} ${badge?.text}`}>
              <Icon name={badge?.icon} size={13} />
              {badge?.label}
            </span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default ApprovalHeader;
